import { render, staticRenderFns } from "./stockCreateModal.vue?vue&type=template&id=18d4df71&"
import script from "./stockCreateModal.vue?vue&type=script&lang=ts&"
export * from "./stockCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports